(function (angular, app) {
   "use strict";

    angular.module(app.modules.common.name)
        .constant(app.modules.common.constants.regionlist,
        
         [
            {id: "AB", region: "Alberta", country: "Canada" },
            {id: "BC", region: "British Columbia", country: "Canada" },
            {id: "MB", region: "Manitoba", country: "Canada" },
            {id: "NB", region: "New Brunswick", country: "Canada" },
            {id: "NL", region: "Newfoundland and Labrador", country: "Canada" },
            {id: "NT", region: "Northwest Territories", country: "Canada" },
            {id: "NS", region: "Nova Scotia", country: "Canada" },
            {id: "NU", region: "Nunavut", country: "Canada" },
            {id: "ON", region: "Ontario", country: "Canada" },
            {id: "PE", region: "Prince Edward Island", country: "Canada" },
            {id: "QC", region: "Québec", country: "Canada" },
            {id: "SK", region: "Saskatchewan", country: "Canada" },
            {id: "YT", region: "Yukon Territory", country: "Canada" },
            {id: "AL", region: "Alabama", country: "United States" },
            {id: "AK", region: "Alaska", country: "United States" },
            {id: "AZ", region: "Arizona", country: "United States" },
            {id: "AR", region: "Arkansas", country: "United States" },
            {id: "CA", region: "California", country: "United States" },
            {id: "CO", region: "Colorado", country: "United States" },
            {id: "CT", region: "Connecticut", country: "United States" },
            {id: "DE", region: "Delaware", country: "United States" },
            {id: "DC", region: "District of Columbia", country: "United States" },
            {id: "FL", region: "Florida", country: "United States" },
            {id: "GA", region: "Georgia", country: "United States" },
            {id: "HI", region: "Hawaii", country: "United States" },
            {id: "ID", region: "Idaho", country: "United States" },
            {id: "IL", region: "Illinois", country: "United States" },
            {id: "IN", region: "Indiana", country: "United States" },
            {id: "IA", region: "Iowa", country: "United States" },
            {id: "KS", region: "Kansas", country: "United States" },
            {id: "KY", region: "Kentucky", country: "United States" },
            {id: "LA", region: "Louisiana", country: "United States" },
            {id: "ME", region: "Maine", country: "United States" },
            {id: "MD", region: "Maryland", country: "United States" },
            {id: "MA", region: "Massachusetts", country: "United States" },
            {id: "MI", region: "Michigan", country: "United States" },
            {id: "MN", region: "Minnesota", country: "United States" },
            {id: "MS", region: "Mississippi", country: "United States" },
            {id: "MO", region: "Missouri", country: "United States" },
            {id: "MT", region: "Montana", country: "United States" },
            {id: "NE", region: "Nebraska", country: "United States" },
            {id: "NV", region: "Nevada", country: "United States" },
            {id: "NH", region: "New Hampshire", country: "United States" },
            {id: "NJ", region: "New Jersey", country: "United States" },
            {id: "NM", region: "New Mexico", country: "United States" },
            {id: "NY", region: "New York", country: "United States" },
            {id: "NC", region: "North Carolina", country: "United States" },
            {id: "ND", region: "North Dakota", country: "United States" },
            {id: "OH", region: "Ohio", country: "United States" },
            {id: "OK", region: "Oklahoma", country: "United States" },
            {id: "OR", region: "Oregon", country: "United States" },
            {id: "PA", region: "Pennsylvania", country: "United States" },
            {id: "RI", region: "Rhode Island", country: "United States" },
            {id: "SC", region: "South Carolina", country: "United States" },
            {id: "SD", region: "South Dakota", country: "United States" },
            {id: "TN", region: "Tennessee", country: "United States" },
            {id: "TX", region: "Texas", country: "United States" },
            {id: "UT", region: "Utah", country: "United States" },
            {id: "VT", region: "Vermont", country: "United States" },
            {id: "VA", region: "Virginia", country: "United States" },
            {id: "WA", region: "Washington", country: "United States" },
            {id: "WV", region: "West Virginia", country: "United States" },
            {id: "WI", region: "Wisconsin", country: "United States" },
            {id: "WY", region: "Wyoming", country: "United States" },
        ]
        
        );
}(angular, app));
